import React, { useState, useEffect, useImperativeHandle, useRef } from "react";
import axios from "axios";
import InsertData from "./InsertVatRates";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { deleteAlert, errorAlert, updateAlert } from "../../Components/Alerts";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import authHeader from "../../Auth/authHeader";
import { ApiLink } from "../../APILink/ApiLink";
import { AiFillEdit, AiOutlineDelete, AiOutlineEdit, AiOutlinePrinter, AiOutlineFilePdf } from "react-icons/ai";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Paper } from "@mui/material";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import jwtDecode from "jwt-decode";
import { MdManageAccounts } from "react-icons/md";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import DataGridComponent from "../../Components/DataGridComponent";

export default function VatRates() {
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        VATID: "",
        VATName: "",
        VATPercent: "",
        ModifiedByUser: "",
        IsActive: false,
    });

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [logedEmail, setLogedEmail] = useState("");
    let number = 1;
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = jwtDecode(token);
            setLogedEmail(decodedToken.email);
        }
    }, []);

    const email = LoginUserDetailed();
    const headers = authHeader();
    const [role, setRole] = useState("");

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'vatrates', { headers });
            setData(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    //Kodi per shfaqjen e tabeles ne PDF
    const handleExportPDF = () => {
        const doc = new jsPDF();
        // Teksti i parë në fillim të dokumentit
        const text1 = "AccounTree";
        doc.text(text1, 10, 10); // 20 është pozicioni X, 10 është pozicioni Y

        // Teksti i dytë në fillim të dokumentit
        const text2 = "VAT Rates List";
        doc.text(text2, 10, 20); // 20 është pozicioni X, 20 është pozicioni Y

        // Teksti i tretë në fillim të dokumentit
        // const text3 = "Accounting is the process of recording financial transactions pertaining to a business.";
        // doc.text(text3, 10, 30); // 20 është pozicioni X, 30 është pozicioni Y
        // const paragraph = "Ky është një paragraf në fillim të tabelës.";
        // doc.text(paragraph, 20, 40); // 20 është pozicioni X, 40 është pozicioni Y
        doc.autoTable({
            head: [["Name", "Percentage %", "Active"]],
            body: filteredData.map((item) => [item.VATName, item.VATPercent, item.IsActive]),
            startY: 30
        });
        doc.save("VATRates-List.pdf");
    };
    //Kodi per shfaqjen e tabeles ne Print
    const tableRef = useRef();

    const handlePrintTable = () => {
        const table = tableRef.current;
        const tableClone = table.cloneNode(true);
        const printWindow = window.open('', 'PrintWindow', 'height=400,width=600');
        printWindow.document.write(tableClone.outerHTML);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    //Kodi per pegination ne tabel
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //Kodi per dizajnin e tabeles
    const styles = {
        tableHeader: {
            backgroundColor: '#466F86',
            color: 'white',

        },
        tableCell: {
            paddingTop: '1px',
            paddingBottom: '1px',

        },

    };
    //Kodi per shfaqjen e loadingut 
    const [loading, setLoading] = useState(true);


    //Ky kod e dergon kerkesen per te fshir nje rresht 
    const handleDelete = async () => {
        try {
            const response = await axios.delete(
                ApiLink.API_URL + 'vatrates' + `/${deleteItemId}`, { headers }
            );
            setShowDeleteConfirmation(false);
            deleteAlert("Vat Rates Deleted Successfully");
            fetchData();
        } catch (error) {
            if (error.response.data) {
                setShowDeleteConfirmation(false);
                deleteAlert("Vat Rates can not be deleted!!!");
            } else {
            }
        }
    };

    //Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setFormData({
            VATID: item.VATID,
            VATName: item.VATName,
            VATPercent: item.VATPercent,
            ModifiedByUser: email,
            IsActive: item.IsActive,
        });
        setShowEditModal(true);
    };

    //Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'vatrates', formData, { headers })
            .then((response) => {
                setShowEditModal(false); // Close the edit modal
                fetchData();
                updateAlert("VAT rate updated successfully");
            })
            .catch((error) => {
                // alert("Failed to update VAT rate");
                errorAlert("Failed to update VAT rate")
            });
    };

    const filteredData = data.filter((item) => {
        return (
            item.VATName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.VATPercent.toString().includes(searchTerm)
        );
    });

    const fetchRole = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AuthProva/getrole', { headers });

            if (response.data.UserRole && response.data.UserRole !== undefined) {
                setRole(response.data.UserRole);
            } else {
                errorAlert("Undefined Role.");
            }
        } catch (error) {
            console.error("Error fetching role:", error);
        }
    };

    const vatRatesGrid = [
        { field: 'id', headerName: '#', width: 75, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
        { field: 'name', headerName: 'Norma e TVSH-së', width: 600, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'percent', headerName: 'Përqindja', width: 600, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },

    ]

    const detailsRows = data.map((item, index) => ({
        id: ++index,
        name: item.VATName,
        percent: item.VATPercent
    }));

    //Ruhen tdhanat 
    useEffect(() => {
        fetchData();
    }, [logedEmail]);

    return (
        <div className="Crud__Container">
            {/* Modal per konfirmin nese deshiron me fshi nje element */}
            <Modal show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Shfaqja  e modalit per editimin e te dhenave  */}
            {showEditModal && (
                <div className="edit-modal">

                    <form onSubmit={handleSubmit}>
                        <h3>Edit Vat Rate</h3>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-3 col-sm-3">ID </span>
                            <input
                                className="form-control"
                                type="number"
                                id="VATID"
                                name="VATID"
                                value={formData.VATID}
                                onChange={handleInputChange}
                                disabled
                            />

                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-3 col-sm-3">Vat Name </span>
                            <input
                                className="form-control"
                                type="text"
                                id="VATName"
                                name="VATName"
                                value={formData.VATName}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-3 col-sm-3">Vat Percent </span>
                            <input
                                className="form-control"
                                type="number"
                                id="VATPercent"
                                name="VATPercent"
                                value={formData.VATPercent}
                                onChange={handleInputChange}
                            />

                        </div>
                        <div className="form-group">
                            <label htmlFor="IsActive">Active</label>
                            <input
                                type="checkbox"
                                id="IsActive"
                                name="IsActive"
                                checked={formData.IsActive}
                                onChange={(event) =>
                                    setFormData({ ...formData, IsActive: event.target.checked })
                                }
                            />
                        </div>
                        <button type="submit" className="btn btn-success">Update</button>

                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowEditModal(false)}
                        >
                            Cancel
                        </button>
                    </form>
                </div>
            )}

            {/* Tabela per shfaqjen e te dhenave  */}
            <div className="header_flex">
                {/* <div className="header_icon">
                    <MdManageAccounts style={{}} className="header_icons" />
                    <h3>Normat e TVSH-së</h3>
                </div> */}
                <TitleElements
                    icon={MdManageAccounts}
                    title="Normat e TVSH-së"
                />
                {
                    role === "acctree" && (
                        <div>
                            <InsertData fetchData={fetchData} />
                        </div>
                    )
                }
            </div>
            {/* <div className="header_paragraph">
                <p>Kjo listë paraqet normat e TVSH-së sipas ligjit në Republikën e Kosovës.</p>
            </div> */}
            <ElementsParagraph text="Kjo listë paraqet normat e TVSH-së sipas ligjit në Republikën e Kosovës." />

            {/* <div className="bordere">
                <div className="butonss">
                    <div>
                        <button className="button-15" onClick={handleExportPDF} variant="contained"><AiOutlineFilePdf /> PDF </button>
                    </div>
                    <div className="butons15">
                        <button className="button-15" variant="contained" onClick={handlePrintTable}><AiOutlinePrinter /> Print</button>
                    </div>
                </div>

                <div className="searchboxx">
                    <div className="flexbox">
                        <div class="search">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search VAT Rates"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}

                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div> */}
            <hr></hr>
            {/* <Paper>
                <TableContainer sx={{ maxHeight: 500 }}>
                    <Table ref={tableRef} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={styles.tableHeader}><strong>#</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Norma e TVSH-së</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong></strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Përqindja</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong></strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Aktiv</strong></TableCell>
                                {
                                    role === "acctree" && (
                                        <TableCell sx={styles.tableHeader}><strong>Actions</strong></TableCell>
                                    )
                                }
                            </TableRow>
                        </TableHead>
                        {loading ? (
                            <div className="spinner" style={{ marginLeft: "560px" }} ></div>
                        ) : (
                            <TableBody>
                                {filteredData
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={item.VATID}>
                                            <TableCell sx={styles.tableCell}>{number + index}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.VATName}</TableCell>
                                            <TableCell sx={styles.tableCell}></TableCell>
                                            <TableCell sx={styles.tableCell}>{item.VATPercent}</TableCell>
                                            <TableCell sx={styles.tableCell}></TableCell>
                                            <TableCell sx={styles.tableCell}>{item.IsActive ? "Yes" : "No"}</TableCell>
                                            {
                                                role === "acctree" && (
                                                    <TableCell sx={styles.tableCell}>
                                                        <Tooltip title="Edit" placement="left">
                                                            <IconButton>
                                                                <AiFillEdit style={{ color: '#466F86' }} onClick={() => handleEdit(item)}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Delete" placement="right">
                                                            <IconButton>
                                                                <DeleteIcon style={{ color: '#962a38' }}
                                                                    onClick={() => {
                                                                        setShowDeleteConfirmation(true);
                                                                        setDeleteItemId(item.BankID);
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                )
                                            }
                                        </TableRow>
                                    ))}
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper> */}

            <DataGridComponent columns={vatRatesGrid} rows={detailsRows} />

        </div>
    );
}
